<template>
  <component
          :is="as"
          v-fade-img
          :alt="alt"
          :class="className"
          :loading="loading"
          :media="media"
          :sizes="sizes"
          :srcset="srcset.join(', ')"
          :type="formats[format]"
  />
</template>

<script lang="ts" setup>
const {uri, dimensions, sizes, media, format = 'jpg', as = 'img', className, alt, loading = 'lazy'} = defineProps<{
    uri: string
    dimensions: { width: number, height?: number }[]
    sizes: string
    media?: string
    format?: keyof typeof formats
    as?: string
    className?: string
    alt?: string
    loading?: string
}>()
const formats = {
    webp: 'image/webp',
    jpg: 'image/jpeg',
    png: 'image/png',
}
const img = useImage();
const srcset = computed(() => {
    return dimensions.map(dimension =>
            `${img(uri, {
                ...dimension,
                format,
            })} ${dimension.width}w`,
    )
})
</script>
